import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

import Input from '../../../form/Input';

function HomologationAssinaturaDialog({ open, onClose, onConfirm, title, confirmLabel = 'Confirmar', loading = false }) {
    const [dados, setDados] = useState({
        usuario: '',
        senha: '',
    });

    useEffect(() => {
        if (!open) return;

        setDados({
            usuario: '',
            senha: '',
        });
    }, [open]);

    function handleChange(e) {
        const { name, value } = e.target;

        setDados((prev) => ({
            ...prev,
            [name]: value,
        }));
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <>
                <DialogTitle>{title}</DialogTitle>

                <DialogContent>
                    <div>
                        <Input
                            text="Usuário"
                            name="usuario"
                            inputWidth="300px"
                            value={dados.usuario || ''}
                            handleOnChange={handleChange}
                        />

                        <Input
                            text="Senha"
                            name="senha"
                            type="password"
                            inputWidth="300px"
                            value={dados.senha || ''}
                            handleOnChange={handleChange}
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="secondary" variant="contained" disabled={loading}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => onConfirm(dados)}
                        color="success"
                        variant="contained"
                        disabled={loading || !dados.usuario || !dados.senha}
                    >
                        {confirmLabel}
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    );
}

export default HomologationAssinaturaDialog;
